import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import styles from "./AddMenuItemModal.module.css";
import { validateForm, validateInput } from "../helpers/helperFunctions";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { flashAlert } from "../global_js";
import EventMenu from "../menus/EventMenu";

function AddMenuItemModal({ eventData, setEventData, getServers, bID, categoryNames, makeInvalid }) {
  const [isOpen, setIsOpen] = useState(false);
  const [menu, setMenu] = useState([]);
  const [searchParam, setSearchParam] = useState("");
  const [selections, setSelections] = useState([]);
  const [selectionsRemaining, setSelectionsRemaining] = useState(0);
  const [totalSelections, setTotalSelections] = useState(0);
  const [selectedMenuItem, setSelectedMenuItem] = useState({});

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setSearchParam("");
    setSelections([]);
    setSelectionsRemaining(0);
    setSelectedMenuItem({});
  };

  const getMenu = async () => {
    try {
      const res = await fetch("/api/menu/" + eventData.LocationID);
      const data = await res.json();
      setMenu(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMenu();
  }, []);

  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0.0);
  const [qty, setQty] = useState(1);
  const [type, setType] = useState("APP");

  //Get all the selections for a specific menu item and display
  const selectMenuItem = async (menuItem, qty) => {
    if (validateInput(qty)) {
      await setSelectedMenuItem({ ...menuItem, quantity: Number(qty.value) });
      await setSelections([]);
      await setTotalSelections(Number(qty.value) * Number(menuItem.selectionCount));
      await setSelectionsRemaining(Number(qty.value) * Number(menuItem.selectionCount));

      await fetch("/api/detail/menuitem/selections/" + menuItem.idBanquetMenu, {
        method: "get",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            //Set required selections to include in banquet
            let updatedData = data.map((sel) => {
              if (!sel.optional) {
                sel.includeInBanquet = true;
                sel.quantity = Number(qty.value);
              }
              return sel;
            });
            setSelections(updatedData);
            document.getElementById(`menutable-${eventData.idBanquetHeader}`).style.display = "none";
            document.getElementById(`menuSearchDiv`).style.display = "none";
          }
        });
    }
  };

  //make sure to lock the standard item selections based on remaining selection count
  useEffect(() => {
    let checkboxes = document.querySelectorAll(`${`#selectionsTable-${eventData.idBanquetHeader}`} input`);
    if (selectionsRemaining == 0) {
      checkboxes.forEach((element) => {
        if (!element.name.endsWith("_ADD") && !element.checked && element.value == 0) {
          element.disabled = true;
        } else if (!element.name.endsWith("_ADD") && !element.checked && element.value > 0) {
          element.setAttribute("max", element.value);
        }
      });
    } else {
      checkboxes.forEach((element) => {
        element.disabled = false;
        element.removeAttribute("max");
      });
    }
  }, [selectionsRemaining]);

  //Add a single menu item
  const addMenuItem = async (menuItem, qty, checkValid) => {
    if (validateInput(qty)) {
      const uniqueId = Math.random().toString(36).substr(2, 9);

      const formData = new URLSearchParams({
        id: bID,
        qty: qty.value,
        menuItemId: menuItem.idBanquetMenu,
        price: menuItem.Price,
        gratPercent: eventData.percentGrat,
        pricePerTotal: menuItem.isPricePer ? menuItem.Price * eventData.BanAttendance * qty.value : qty.value * menuItem.Price,
        hasParent: uniqueId,
      });

      await fetch("/api/detail/", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          setEventData({
            ...eventData,
            serviceTotal: data.priceUpdate.serviceTotal,
            fbTotal: data.priceUpdate.fbTotal,
            barTotal: data.priceUpdate.barTotal,
            details: data.details,
          });
          getServers();
        });
      closeModal();
    }
  };

  //Add a menu item that has optional choices or side items
  const addMenuItemWithOptions = async () => {
    const submitData = {};
    submitData.gratPercent = eventData.percentGrat;
    submitData.banId = eventData.idBanquetHeader;
    submitData.menuitems = [];

    //Set total price including addons
    let addOnPrice = 0;
    selections.map((sel) => {
      if (sel.includeInBanquet) {
        addOnPrice += Number(sel.Price);
      }
    });

    const uniqueId = Math.random().toString(36).substr(2, 9);

    //Add the Parent menu Item
    let row = {};
    row.banid = eventData.idBanquetHeader;
    row.menuid = selectedMenuItem.idBanquetMenu;
    row.qty = selectedMenuItem.quantity;
    row.price = Number(selectedMenuItem.Price);
    row.parentCode = uniqueId;
    row.addOnPrice = addOnPrice;
    row.menuItemNotes = "";
    row.isParent = true;
    row.pricePerTotal = selectedMenuItem.isPricePer
      ? Number(eventData.BanAttendance) * (Number(addOnPrice) + Number(selectedMenuItem.Price * selectedMenuItem.quantity))
      : Number(addOnPrice + selectedMenuItem.Price);
    submitData.menuitems.push(row);

    selections.forEach((sel) => {
      row = {};
      if (sel.includeInBanquet) {
        row.banid = eventData.idBanquetHeader;
        row.menuid = sel.idBanquetMenu;
        row.qty = sel.quantity;
        row.price = sel.Price;
        addOnPrice = 0;
        row.parentCode = uniqueId;
        row.menuItemNotes = "";
        row.isParent = false;
        row.pricePerTotal = 0;
        submitData.menuitems.push(row);
      }
    });
    await fetch("/api/detail/menuitem/selections", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submitData),
    })
      .then((res) => res.json())
      .then((data) => {
        setEventData({
          ...eventData,
          serviceTotal: data.priceUpdate.serviceTotal,
          fbTotal: data.priceUpdate.fbTotal,
          barTotal: data.priceUpdate.barTotal,
          details: data.details,
        });
        getServers();
      });
    closeModal();
  };

  const menuQtyChanged = (qty) => {};

  const checkboxChanged = async (select, ctl) => {
    let ctlValue = Number(ctl.target.value);

    //Check to make sure that the number entered does not exceed the max remaining
    if (select.Category.endsWith("_IT") && ctlValue > selectionsRemaining) {
      //set value to <= current if remaining is zero
      if (ctlValue > select.quantity && selectionsRemaining == 0) {
        ctlValue = select.quantity;
        ctl.target.value = select.quantity;
      } else {
        //or set to selectionsremaining
        ctl.target.value = selectionsRemaining;
        ctlValue = selectionsRemaining;
      }
    }
    let totalQuantity = 0;
    const theId = select.idBanquetMenu;
    select.quantity = ctlValue;

    const newArray = selections.map((selection) => {
      if (selection.Category.endsWith("_IT")) {
        totalQuantity += Number(selection.quantity);
      }
      if (Number(selection.quantity) > 0 || !selection.optional) {
        selection.includeInBanquet = true;
      } else {
        selection.includeInBanquet = false;
      }
      return selection;
    });
    if (!select.Category.endsWith("_ADD") || select.Category != "SIDE") {
      await setSelectionsRemaining(totalSelections - totalQuantity);
    }
    setSelections(newArray);
    // if (select.includeInBanquet && !select.Category.endsWith("_ADD")) {
    //   setSelectionsRemaining(selectionsRemaining - 1);
    // } else if (!select.includeInBanquet && !select.Category.endsWith("_ADD")) setSelectionsRemaining(selectionsRemaining + 1);
  };

  const clearSelections = async () => {
    let qtyBoxes = document.querySelectorAll(`${`#selectionsTable-${eventData.idBanquetHeader}`} input`);
    qtyBoxes.forEach((box) => {
      box.value = 0;
    });
    const resetArray = selections.map((select) => {
      select.quantity = 0;
      select.includeInBanquet = false;
      return select;
    });

    await setSelections(resetArray);
    setSelectionsRemaining(totalSelections);
    //selectMenuItem(selectedMenuItem, selectMenuItem.quantity);
  };

  const cancelMenuItem = () => {
    setSelections([]);
    document.getElementById(`menutable-${eventData.idBanquetHeader}`).style.display = "block";
    document.getElementById(`menuSearchDiv`).style.display = "block";
  };

  return (
    <>
      <Button type="tertiary" onClick={openModal}>
        Add Menu Item
      </Button>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content ${styles.modalTop}`}>
            <h3 className="modal-header">Add Menu Item</h3>
            <div id="menuSearchDiv" className={styles.menuSearch}>
              <label htmlFor="">Find menu item:</label>
              <input type="text" name="" id="" placeholder="Search" onChange={(e) => setSearchParam(e.target.value)} />
            </div>
            <div className={styles.menuItemDiv}>
              <table id={`menutable-${eventData.idBanquetHeader}`} className={styles.menuItemTable}>
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th>Has Options</th>
                    <th>Quantity</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {menu
                    .filter((sel) => sel.Item.toLowerCase().includes(searchParam.toLocaleLowerCase()))
                    // .slice(0, 12)
                    .map((item) => {
                      return (
                        <tr key={item.idBanquetHeader}>
                          <td>
                            {item.Item}
                            <input type="hidden" name="idMenu" value={item.idBanquetMenu} />
                          </td>
                          <td>{categoryNames.filter((el) => el.id == item.Category)[0].descriptions}</td>
                          <td>
                            <input type="number" className={styles.label} name="currentPrice" value={Number(item.Price).toFixed(2)} readOnly />
                            {item.isPricePer ? <span>/person</span> : ""}
                          </td>
                          <td>{item.hasSelections ? item.selectionCount : ""}</td>
                          <td>
                            <input
                              className={styles.qtyInput}
                              type="number"
                              id={`qty-${item.idBanquetMenu}`}
                              name="qty"
                              onInvalid={makeInvalid}
                              onChange={(e) => menuQtyChanged(e.target)}
                              required
                            />
                          </td>
                          <td>
                            {item.hasSelections ? (
                              <Button
                                type="secondary"
                                onClick={() => selectMenuItem(item, document.getElementById(`qty-${item.idBanquetMenu}`))}
                                id={`btn-${item.idBanquetMenu}`}
                              >
                                SELECT OPTIONS
                              </Button>
                            ) : (
                              <Button type="secondary" onClick={() => addMenuItem(item, document.getElementById(`qty-${item.idBanquetMenu}`))}>
                                ADD ITEM
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {selections.length > 0 && (
                <div className={styles.selectionBlock}>
                  <h4>Select select items for: </h4>
                  <div className={styles.selectionTitle}>
                    <p className={styles.selectionMenuName}>{selectedMenuItem.Item}</p>
                    <p className={styles.selectionMenuQuantity}>Quantity ordered: {selectedMenuItem.quantity}</p>
                    <Button type="pOutline" onClick={cancelMenuItem}>
                      Cancel
                    </Button>
                  </div>
                  <div className={styles.selectionTitle}>
                    <p className={styles.selectionRemaining}>
                      Remaining selections: <span className={styles.selectionMenuCount}>{selectionsRemaining}</span>
                    </p>
                    <Button type="sOutline" onClick={clearSelections}>
                      Clear Selections
                    </Button>
                  </div>

                  <table id={`selectionsTable-${eventData.idBanquetHeader}`} className={styles.selectionsTable}>
                    <thead>
                      <th>Qty</th>
                      <th>Standard Items</th>
                      <th>Type</th>
                      <th>Additional Price</th>
                    </thead>
                    <tbody>
                      {selections
                        .filter((sel) => !sel.Category.endsWith("_ADD"))
                        .map((selection) => {
                          return (
                            <tr>
                              <td>
                                {selection.optional && (
                                  <input
                                    className={styles.selectionCheck}
                                    type="number"
                                    name={selection.Category}
                                    defaultValue={0}
                                    min={0}
                                    //max={selectionsRemaining}
                                    onChange={(e) => checkboxChanged(selection, e)}
                                    onFocus={(e) => e.target.select()}
                                    //checked={selection.includeInBanquet}
                                  />
                                )}
                              </td>
                              <td>{selection.Item}</td>
                              <td>{categoryNames.filter((el) => el.id == selection.Category)[0].descriptions}</td>
                              <td></td>
                            </tr>
                          );
                        })}
                    </tbody>

                    {selections.filter((sel) => sel.Category.endsWith("_ADD")).length > 0 && (
                      <tfoot>
                        <tr>
                          <th></th>
                          <th>Addon Items</th>
                          <th></th>
                          <th></th>
                        </tr>
                        {selections
                          .filter((sel) => sel.Category.endsWith("_ADD"))
                          .map((selection) => {
                            return (
                              <tr>
                                <td>
                                  <input
                                    className={styles.selectionCheck}
                                    type="number"
                                    name={selection.Category}
                                    defaultValue={0}
                                    min={0}
                                    onChange={(e) => checkboxChanged(selection, e)}
                                  />
                                </td>
                                <td>{selection.Item}</td>
                                <td>{categoryNames.filter((el) => el.id == selection.Category)[0].descriptions}</td>
                                <td>{Intl.NumberFormat("en", { currency: "USD", style: "currency" }).format(selection.Price)}</td>
                              </tr>
                            );
                          })}
                      </tfoot>
                    )}
                  </table>
                  <Button type="primary" onClick={addMenuItemWithOptions}>
                    Add Menu Item
                  </Button>
                </div>
              )}
            </div>
            {/* <form className={styles.otherMenuItemForm} onSubmit={addOtherFoodItem} noValidate>
              <h4>Add other menu item</h4>
              <div className={styles.otherMenuItemBody}>
                <div className={styles.formSection}>
                  <input
                    type="text"
                    name="description"
                    className={styles.otherDesc}
                    placeholder="Enter description"
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item description required</div>
                </div>
                <div className={styles.formSection}>
                  <select name="type" onChange={(e) => setType(e.target.value)} value={type}>
                    <option value="APP">Appetizer</option>
                    <option value="ENT">Entree</option>
                    <option value="DES">Dessert</option>
                    <option value="BEV-NA">Non-Alcoholic Beverage</option>
                    <option value="BEV">Bar Beverage</option>
                  </select>
                </div>
                <div className={styles.formSection}>
                  <input
                    type="number"
                    name="price"
                    className={styles.otherPrice}
                    step=".01"
                    placeholder="Enter price"
                    onChange={(e) => setPrice(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item price required</div>
                </div>
                <div className={styles.formSection}>
                  <input
                    type="number"
                    name="qty"
                    className={styles.otherQty}
                    placeholder="Enter quantity"
                    onChange={(e) => setQty(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item quantity required</div>
                </div>
                <Button type="secondary">Add Other Item</Button>
              </div>
            </form> */}
            <div className={styles.formSelectButtons}>
              {/* <Button type="primary">Save</Button> */}
              <Button type="save" onClick={closeModal}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddMenuItemModal;
